import { Link } from "react-router-dom";
import {
  LICENSE_AGREEMENT_TEXT,
  buildLicenseAgreementRenderRows,
} from "../utils/licenseAgreement";
import { LicenseAgreementFormattedRows } from "../utils/licenseAgreementRichText";
import "./SecurityPolicy.scss";

export const LicenseAgreement = () => {
  const licenseRows = buildLicenseAgreementRenderRows(LICENSE_AGREEMENT_TEXT);

  return (
    <div className="security-policy-page">
      <div className="security-policy-container">
        <Link to="/" className="security-policy-back">
          ← На главную
        </Link>
        <h1 className="security-policy-title">Лицензионное соглашение</h1>
        <div className="security-policy-body">
          <LicenseAgreementFormattedRows
            rows={licenseRows}
            lineClass="policy-text-line"
            lineClassSubpoint="policy-text-line policy-text-line--subpoint"
            linkClass="policy-inline-link"
          />
        </div>
      </div>
    </div>
  );
};
